import React from 'react';

// Styles & Assets
import styles from './CircleSelector.module.css';

// CircleSelector: component that renders a clickable circle and a text. It 
// can be used in a multi-answer form. Ex: In the TryPollDialog component.
// Received props:
//  -text: text displayed at right of circle
//  -active: boolean indicating that input is marked
//  -handleClick: function that handles a click
const CircleSelector: React.FC<{
    text: string,
    active: boolean,
    size?: number
    handleClick?: () => void,
}> = ({ text, active, size, handleClick }) => {

    return (
        <button className={styles.options} onClick={handleClick}>
            <input type ='radio' checked={active} style={{height: size, width: size}} className={styles.optionSelector} readOnly/>
            <label>{text}</label>
        </button>
    );
};

export default CircleSelector;